import React from 'react'

export const formatNumber = number => {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(number);
}

export const getDatebookImageFolder = (datebookType, displayName) => {
    // Special case for USA
    if (displayName === "USA") {
        return "USA Datebooks";
    }

    switch (datebookType) {
        case 'CITY':
            return 'City Datebooks';
        case 'PHOTO':
            if (["San Francisco", "Dallas"].includes(displayName)) {
                return 'City Datebooks';   // special case
            }
            return 'Photo Datebooks';
        case 'DAY_BY_DAY':
            return 'Day By Day Datebooks';
        case 'HEALTH':
            return 'Health Datebooks';
        default:
            console.error('non-existent datebook type')
            return;
    }
}

export const getPDPText = (datebookType, displayName, includeEmailLink) => {
    let headerDescription, specificFeatureList;

    switch (datebookType) {
        case 'CITY':
            headerDescription = (
                <p>
                    The {displayName} Datebook Weekly Planner is not only a practical daily planner,
                    but it is also a valuable resource guide! It will help you keep track of all important
                    dates in your life and give you insight into the beautiful city you are in.
                </p>
            )
            specificFeatureList = (
                <ul className="text-left">
                    <li>Helpful city resources such as city maps, transportation information, sports information and schedules, local attractions, a calendar of city events, and more!</li>
                    <li>3 Year Reference Calendar.</li>
                    <li>List of important Dates and Holidays.</li>
                    <li>Pages for Birthdays and Anniversaries.</li>
                    <li>Restaurant & Entertainment and Book & Music & Movie Recommendations.</li>
                </ul>
            )
            return (
                <>
                    {headerDescription}
                    {specificFeatureList}
                </>
            )

        case 'PHOTO':
            if (displayName === "USA") {
                // Special USA description
                headerDescription = (
                    <p>
                        The USA Datebook Weekly Planner helps you keep track of important dates with weekly
                        and monthly layouts—without additional city or state-specific resources.
                    </p>
                )
                specificFeatureList = (
                    <ul className="text-left">
                        <li>3 Year Reference Calendar.</li>
                        <li>List of important Dates and Holidays.</li>
                        <li>Pages for Birthdays and Anniversaries.</li>
                        <li>Extra pages for notes and planning.</li>
                    </ul>
                )
            } else if (["San Francisco", "Dallas"].includes(displayName)) {
                headerDescription = (
                    <p>
                        The {displayName} City Datebook Weekly Planner is not only a practical daily planner,
                        but it is also a valuable resource guide! Use it to keep track of important dates
                        with weekly and monthly calendar layouts, plus helpful city information.
                    </p>
                )
                specificFeatureList = (
                    <ul className="text-left">
                        <li>Helpful city resources such as maps, transportation, sports info, local attractions, events, and more!</li>
                        <li>3 Year Reference Calendar.</li>
                        <li>Important Dates and Holidays.</li>
                        <li>Pages for Birthdays and Anniversaries.</li>
                        <li>Restaurant, Entertainment, and Book/Music/Movie Recommendations.</li>
                    </ul>
                )
            } else {
                headerDescription = (
                    <p>
                        The {displayName} Photo State Datebook Weekly Planner includes scenic color photos of {displayName}
                        on the cover and throughout the book. It is not only beautiful and practical—it includes valuable
                        state resources as well!
                    </p>
                )
                specificFeatureList = (
                    <ul className="text-left">
                        <li>Helpful state resources such as maps, transportation, sports info, local attractions, events, and more!</li>
                        <li>3 Year Reference Calendar.</li>
                        <li>Important Dates and Holidays.</li>
                        <li>Pages for Birthdays and Anniversaries.</li>
                        <li>Restaurant, Entertainment, and Book/Music/Movie Recommendations.</li>
                    </ul>
                )
            }

            return (
                <>
                    {headerDescription}
                    {specificFeatureList}
                </>
            )

        case 'DAY_BY_DAY':
            headerDescription = (
                <p>
                    Day by Day (Christian) Datebooks will help you keep track of all important dates in your life.
                    Not only do they come with “Week at a Glance” and “Month at a Glance” pages for you to use as a planner,
                    but they also include sixteen pages of biblical references in addition to:
                </p>
            )
            specificFeatureList = (
                <ul className="text-left">
                    <li>List of books of the Bible</li>
                    <li>List of Parables</li>
                    <li>List of Ten Commandments</li>
                    <li>List of Miracles</li>
                    <li>List of Letters of Paul</li>
                    <li>Glossary of theological terms</li>
                    <li>Weight/Measurement conversions</li>
                </ul>
            )
            return (
                <>
                    {headerDescription}
                    {specificFeatureList}
                </>
            )

        case 'HEALTH':
            return (
                <>
                    <p>{displayName} is designed to help you organize important health and wellness information in one place.</p>
                    <ul className="text-left">
                        <li>Doctor appointments and treatment changes</li>
                        <li>Medication and prescription history</li>
                        <li>Medical history and procedures</li>
                        <li>Health and wellness goal tracking</li>
                        <li>Staying healthy tips</li>
                        <li>Important questions and notes for doctors</li>
                    </ul>
                </>
            );

        default:
            return;
    }
}

function capitalizeWords(str) {
    return str.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
}

export function getPDPTitleMetadata(datebookType, displayName) {
    let retName = displayName;

    if (displayName === "USA") {
        retName = "USA Datebook";   // special case, no city/state
    } else if (datebookType === 'PHOTO' && ["San Francisco", "Dallas"].includes(displayName)) {
        retName = `${displayName} City Datebook`;
    } else if (datebookType !== 'DAY_BY_DAY') {
        retName = `${displayName} ${capitalizeWords(datebookType)}`;
    }

    return retName;
}
